import { BaseColumnFormatter } from "./BaseColumnFormatter";

export class IntegerFormatter extends BaseColumnFormatter
{
    constructor(width: string = "125px")
    {
        super();
        this.width = width;
    }
    override format(value: any): any
    {
        try
        {
            if (value != null)
                return (value as number).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
        } catch (e)
        {
        }
        return value;
    }
}